/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum InternalApiSearchOperator {
    IS_EXACTLY = 'IS_EXACTLY',
    STARTS_WITH = 'STARTS_WITH',
    ENDS_WITH = 'ENDS_WITH',
    CONTAINS = 'CONTAINS',
    CONTAINS_WORD = 'CONTAINS_WORD',
    GT = 'GT',
    GTE = 'GTE',
    LT = 'LT',
    LTE = 'LTE',
    EXISTS = 'EXISTS'
}


export function instanceOfInternalApiSearchOperator(value: any): boolean {
    for (const key in InternalApiSearchOperator) {
        if (Object.prototype.hasOwnProperty.call(InternalApiSearchOperator, key)) {
            if (InternalApiSearchOperator[key as keyof typeof InternalApiSearchOperator] === value) {
                return true;
            }
        }
    }
    return false;
}

export function InternalApiSearchOperatorFromJSON(json: any): InternalApiSearchOperator {
    return InternalApiSearchOperatorFromJSONTyped(json, false);
}

export function InternalApiSearchOperatorFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiSearchOperator {
    return json as InternalApiSearchOperator;
}

export function InternalApiSearchOperatorToJSON(value?: InternalApiSearchOperator | null): any {
    return value as any;
}

export function InternalApiSearchOperatorToJSONTyped(value: any, ignoreDiscriminator: boolean): InternalApiSearchOperator {
    return value as InternalApiSearchOperator;
}

